import { RoutePath } from "#utils/route";
import { FlowDetailRoute } from "#routes/organization/flows/[flowId]/detail";

export const FlowRecordDetailRoute = FlowDetailRoute.concat(
  new RoutePath<"recordId">({
    path: "/record/:recordId",
    title: "Flow Record Details",
  })
);
